module.exports = __webpack_public_path__ + "img/inbox-disabled.c58cd903.svg";